import { ClarityComponent } from './Clarity';

export function Integrations() {
  return (
    <>
      <ClarityComponent />
    </>
  );
}
